/**
 * String Utility Functions
 *
 * Simple string replacement utilities.
 */

/**
 * Replace all occurrences of a string
 * @param str - The input string
 * @param search - The string to search for
 * @param replace - The replacement string
 * @returns Modified string with all occurrences replaced
 */
export function replaceAll(str: string, search: string, replace: string): string {
  return str.split(search).join(replace);
}

/**
 * Convert newlines to HTML break tags
 * @param str - The input string
 * @param is_xhtml - Whether to use XHTML-compatible breaks
 * @returns String with newlines converted to <br> tags
 */
export function nl2br(str: string | null | undefined, is_xhtml?: boolean): string {
  if (typeof str === "undefined" || str === null) {
    return "";
  }
  const breakTag = is_xhtml || typeof is_xhtml === "undefined" ? "<br />" : "<br>";
  return str.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "$1" + breakTag + "$2");
}

/**
 * Generate a random number between min and max
 * @param min - Minimum value
 * @param max - Maximum value
 * @returns Random number
 */
export function randnum(min: number, max: number): number {
  return Math.round(Math.random() * (max - min) + min);
}

/**
 * Calculate hash code for a string (used for file upload tracking)
 * @param s - Input string
 * @returns Hash code number
 */
export function hashCode(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  }
  return h;
}

/**
 * Round number to 2 decimal places
 * @param num - Number to round
 * @returns Rounded number
 */
export function perfectround(num: number): number {
  return Math.round((num + Number.EPSILON) * 100) / 100;
}

/**
 * Get random integer between min and max (exclusive max)
 * @param min - Minimum value (inclusive)
 * @param max - Maximum value (exclusive)
 * @returns Random integer
 */
export function getRandomInt(min: number, max: number): number {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
}
